
import { update_cookie } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/cookies.js?1733898722586';
import { get_cookie_name } from '/srv/web/wyvr/html/releases/58819/gen/client/odoscope/api/get_cookie_name.js?1733898722586';

export function set_cookie(oscCookie, token) {
    if (false || !oscCookie || !token) {
        return;
    }
    Object.entries(oscCookie).forEach(([key, value]) => {
        if (key == get_cookie_name(token)) {
            // set the cookie for the next 30 days
            const date = new Date();
            // 30 * 24 * 60 * 60 * 1000
            date.setTime(date.getTime() + 2592000000);
            update_cookie(key, value, { expires: date.toUTCString() });
        }
    });
}
